<script  setup>
import {reactive, ref, watch} from "vue";
import {ElButton, ElCol, ElLoading, ElMessage, ElRow} from "element-plus";
import axios from "axios";
const props = defineProps({
    destinations:Object,
    itineries:Object,
    form:Object
});
import moment from 'moment';
const emit = defineEmits(['canceli','added']);
const ruleFormRef = ref()
const destinations=props.destinations;
const itineries=props.itineries;
const eform=props.form;
const searchinp=ref('');
const model=ref(true);
import { moneyTotal, roundMoney } from '../../../utils/money';

const attractionlist = ref([]);

const loaddata = () => {
    const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
    });

    axios.post('/activityapi/searchdestactivity',{'destinations':destinations})
        .then(function (response) {
            model.value = true
            attractionlist.value =response.data.data;
            console.log(response.data.data);
            console.log(attractionlist.value);
            loading.close()
        }).catch(error => {
        loading.close();
    });
}
loaddata();

const filtered=()=>{
    return attractionlist.value.filter(item => item.name.toLowerCase().includes(searchinp.value) );
}
const addatr = (aitem) => {

    const images = [];
    if (aitem.image && String(aitem.image).toLowerCase().indexOf('noimage') === -1) {
        images.push(aitem.image);
    }

    let item={
        'id':aitem.id,
        'name':aitem.name,
        'image':images[0] || '',
        'images':images,
         'pricing':{}
        };


    let tprice={
        total:0,
        adult:0,
        infant:0,
        child:0
    };

    tprice.adult=roundMoney(aitem.pricing.adult);
    tprice.child=eform.childs>0 ? roundMoney(aitem.pricing.child) : 0;
    tprice.infant=eform.infants>0 ? roundMoney(aitem.pricing.infant) : 0;
    tprice.total=moneyTotal(eform.adults, tprice.adult, eform.childs, tprice.child, eform.infants, tprice.infant);
    item.pricing=tprice;

    itineries.activities.push(item);

    if(aitem.transfers){
        aitem.transfers.id="id"+moment().format('x');
        let tprice={
            total:0,
            adult:0,
            infant:0,
            child:0
        };


        aitem.transfers.pricing=tprice;

        itineries.transfers.push(aitem.transfers)
    }

    ElMessage({
        message: 'Activity Added Sucessfully.',
        type: 'success',
    })
    emit('added')
}

const isadded = (item) => {

    if(itineries.activities.some(data => data.id === item.id)){
        return true
    }
    else{
        return false
    }
}


const addformmodel=ref(false);

const addform=reactive(
    {
        "name":'',
        "pricing":{
            "total":0,
            "adult":0 ,
            "child":0 ,
            "infant":0 ,
        }
    }
)

const addnewactivity = () => {

    addformmodel.value=true;
    addform.name="";
    addform.pricing.total=0;
    addform.pricing.adult=0;
    addform.pricing.child=0;
    addform.pricing.infant=0;
}


watch(
    () => addform.pricing,
    () => {
        updateupricecount();
    },
    { deep: true }
)

const updateupricecount = () => {
    addform.pricing.total = moneyTotal(eform.adults, addform.pricing.adult, eform.childs, addform.pricing.child, eform.infants, addform.pricing.infant);
};

const submitForm = async (formEl) => {

    if (!formEl) return
    await formEl.validate((valid, fields) => {

        if (valid) {

            let item={
                'id':"id"+moment().format('x'),
                'name':addform.name,
                'image':'',
                'images':[],
                'pricing':{
                    "total":roundMoney(addform.pricing.total),
                    "adult":roundMoney(addform.pricing.adult) ,
                    "child":roundMoney(addform.pricing.child) ,
                    "infant":roundMoney(addform.pricing.infant)
                }
            };

            itineries.activities.push(item);
            addformmodel.value=false;

            ElMessage({
                message: 'Activity Added Sucessfully.',
                type: 'success',
            })

            emit('added')
        }
    })
}


</script>

<template>


    <el-drawer
        size="80%"
        v-model="model"
        :title="'Day - '+itineries.day+' Activities'"
        @closed="emit('canceli')"
    >
        <el-row>
            <el-col :span="24">
                <el-button class="mb-2" type="primary" size="small" @click="addnewactivity">Add New Activity</el-button>
                <el-input v-model="searchinp" clearable class="mb-2"  placeholder="Search here...." />

                <el-card class="mb-3" v-for="item in filtered()" shadow="never" :body-style="{padding:0}">
                    <div class="flex">
                        <el-avatar shape="square" :src="item.image" style="min-width: 100px" :size="150" fit="cover" />
                        <div class="p-2">
                            <p>
                                <el-text tag="b">{{item.name}} / {{item.destination}}</el-text>
                                <el-tag class="ml-2" v-for="tag in item.tags"  type="primary" size="small">
                                    {{ tag }}
                                </el-tag>
                            </p>
                            <p>
                                <el-text tag="b" size="small">Duration : {{item.duration }}</el-text>
                                <el-tag class="ml-2" v-for="tag in item.timings"  type="primary" size="small">
                                    {{ tag }}
                                </el-tag>
                            </p>
                            <p>
                                <el-text tag="b" size="small">Pricing : A-{{item.pricing.adult }} / C-{{item.pricing.child }}  / I-{{item.pricing.infant }}</el-text>

                            </p>
                            <p v-if="item.transfers">
                                <el-text tag="b" size="small">Transfer : </el-text>
                                <el-tag  type="success" size="small">
                                    <b>{{ item.transfers.type }}</b>
                                </el-tag>
                                <el-tag size="small" class="ml-2" v-if="item.transfers.vechile"  type="success">
                                    <b>{{ item.transfers.vechile }}</b>
                                </el-tag>
                                <el-tag size="small" class="ml-2"  v-for="(point,index) in item.transfers.pointslist"   type="primary">
                                    <b>{{ point }}</b>
                                </el-tag>
                            </p>

                            <el-button size="small" v-if="isadded(item)" type="success" >Added</el-button>
                            <el-button size="small" v-else type="primary" @click="addatr(item)">Add</el-button>
                        </div>
                    </div>
                </el-card>

            </el-col>
        </el-row>
    </el-drawer>

    <el-dialog
        v-model="addformmodel"
        title="Add Activity"
        width="50%"

    >
        <el-form
            ref="ruleFormRef"
            :model="addform"
            status-icon
            label-width="auto"
            class="demo-ruleForm"
            label-position="top"
            size="small"

        >
            <el-row :gutter="20">
                <el-col :span="24" >
                    <el-form-item label="Activity Name" prop="name" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="addform.name"  placeholder="Activity Name" />
                    </el-form-item>

                </el-col>



            </el-row>
            <el-row :gutter="20">
                <el-col :span="4" >
                    <el-form-item label="Adults" >
                        <el-input v-model="eform.adults"  placeholder="Adults" readonly/>
                    </el-form-item>

                </el-col>
                <el-col :span="4" >
                    <el-form-item label="Adult Pricing" prop="pricing.adult" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="addform.pricing.adult"  placeholder="Adult Pricing" type="number" />
                    </el-form-item>

                </el-col>


            </el-row>
            <el-row :gutter="20" v-if="eform.childs>0">
                <el-col :span="4" >
                    <el-form-item label="Child" >
                        <el-input v-model="eform.childs"  placeholder="Child" readonly/>
                    </el-form-item>

                </el-col>
                <el-col :span="4" >
                    <el-form-item label="Child Pricing" prop="pricing.child" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="addform.pricing.child"  placeholder="Child Pricing"  type="number" />
                    </el-form-item>

                </el-col>


            </el-row>
            <el-row :gutter="20" v-if="eform.infants>0">
                <el-col :span="4" >
                    <el-form-item label="Infants" >
                        <el-input v-model="eform.infants"  placeholder="Infants" readonly/>
                    </el-form-item>

                </el-col>
                <el-col :span="4" >
                    <el-form-item label="Infants Pricing" prop="pricing.infant" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="addform.pricing.infant"  placeholder="Infants Pricing"  type="number"/>
                    </el-form-item>

                </el-col>


            </el-row>
            <el-row :gutter="20" >
                <el-col :span="4" >


                </el-col>
                <el-col :span="4" >
                    <el-form-item label="Total Pricing" prop="pricing.total" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                        <el-input v-model="addform.pricing.total"  placeholder="Total Pricing"  type="number" readonly/>
                    </el-form-item>

                </el-col>


            </el-row>


        </el-form>


        <template #footer>
            <div class="dialog-footer">
                <el-button @click="addformmodel = false">Cancel</el-button>
                <el-button type="primary" @click="submitForm(ruleFormRef)">
                    Save
                </el-button>
            </div>
        </template>

    </el-dialog>
</template>

<style scoped>

</style>
